import React, { memo } from 'react';
import {isSet} from '../../../../Utils/CommonFunctions';
// import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';


const HyperLink = (props)=>{
  const {colData,id,header} = props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      let headerAtt={}
      try{
        headerAtt = {
          ...header.attributes,
          class:header.attributes.class+' '+(colData.className)?colData.className:''
        }
      }catch(e){

      }
      
        return(
            <td key={"column"+id} {...header.attributes}>
                <span className="tbodyTitle">
                <a  
                    {...eventsHandler}
                    {...headerAtt} 
                    {...colData.attributes}
                    className={(colData.className)?colData.className:''}
                    // data-tip={colData.value}
                    title={colData.value} >
                    {colData.iconClass ? (
                      <i className={colData.iconClass} aria-hidden="true" />
                    ) : null}
                    {isSet(colData.value,null) ? 
                      (isSet(colData.value,'').toString().length < 50 ) ? 
                        colData.value: isSet(colData.value,'').toString().substring(0,50)+'...' : '-'}
                </a>
                
                </span>
            </td>
        );
}


const isDiffProps = (prevProps,nextProps)=>{
  let prevPropsAttributesId = '';
  let nextPropsAttributesId = '';
  try{
    prevPropsAttributesId = prevProps.colData.attributes.id;
    nextPropsAttributesId = nextProps.colData.attributes.id;
  }catch(e){

  }

  if(JSON.stringify(prevProps.colData.value)===JSON.stringify(nextProps.colData.value)
    && prevProps.colData.iconClass === nextProps.colData.iconClass
    && prevPropsAttributesId===nextPropsAttributesId){
    return true;
  }
} 

export default memo(HyperLink,isDiffProps);